// {
// 	"nr": 0,
// 	"tekst": "string",
// 	"kraeverFritekst": true
// }

export interface RejectReasonData {
    nr: number
    tekst: string
    kraeverFritekst: boolean
}

export class RejectReason {
    id: number

    text: string

    requiresFreeText: boolean

    public static build(data: RejectReasonData): RejectReason {
        const rejectReason = new RejectReason()
        rejectReason.id = data.nr
        rejectReason.text = data.tekst
        rejectReason.requiresFreeText = data.kraeverFritekst ?? false
        return rejectReason
    }
}
